// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import TrixNotesController from "./trix_notes_controller"
import AutoSubmitController from "./auto_submit_controller"
import InlineSidebarController from "./inline_sidebar_controller"
import MobileNavController from "./mobile_nav_controller"
import ClickableRowController from "./clickable_row_controller"
import MonthSliderController from "./month_slider_controller"
import WeekSwipeController from "./week_swipe_controller"
import CalendarScrollController from "./calendar_scroll_controller"
import ShowPasswordController from "./show_password_controller"
import BulkSmsController from "./bulk_sms_controller"
import PushNotificationController from "./push_notification_controller"
import PaymentQrController from "./payment_qr_controller"
import ModalController from "./modal_controller"
import SmsTemplatesWarningController from "./sms_templates_warning_controller"

application.register("trix-notes", TrixNotesController)
application.register("auto-submit", AutoSubmitController)
application.register("inline-sidebar", InlineSidebarController)
application.register("mobile-nav", MobileNavController)
application.register("clickable-row", ClickableRowController)
application.register("month-slider", MonthSliderController)
application.register("week-swipe", WeekSwipeController)
application.register("calendar-scroll", CalendarScrollController)
application.register("show-password", ShowPasswordController)
application.register("bulk-sms", BulkSmsController)
application.register("push-notification", PushNotificationController)
application.register("payment-qr", PaymentQrController)
application.register("modal", ModalController)
application.register("sms-templates-warning", SmsTemplatesWarningController)
